<template>
  <div>
    <el-dialog
      :title="dialogOption.title"
      :visible.sync="dialogOption.dialogVisible"
      :before-close="close"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form ref="form" :model="formData" :rules="rules" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="'面料颜色名称'" prop="fabricColorTitle">
              <el-select
                v-model="formData.fabricColorTitle"
                :placeholder="'请选择...'"
                size="medium"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in colorPantoneOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'需求数量'" prop="requestQuantity">
              <el-input
                v-model="formData.requestQuantity"
                size="medium"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    params: {
      default: null,
      type: Object,
    },
  },
  data() {
    let number = /^\d+(\.\d{1,4})?$/
    let checkQuantity = (rule, value, callback) => {
      if (value) {
        if (!number.test(value)) {
          callback(new Error('只能为数字,最多精确到小数点后4位'))
        }
        callback()
      }
      callback(new Error('请填写需求数量'))
    }
    return {
      type: '',
      dialogOption: {
        title: '新增',
        dialogVisible: false,
      },
      formData: {
        fabricRequestColorCode: '',
        fabricRequestCode: '',
        fabricCode: '',
        fabricNo: '',
        fabricColorNo: '',
        fabricColorTitle: '',
        requestQuantity: '',
      },
      colorPantoneOptions: [],
      rules: {
        fabricColorTitle: [
          {
            required: true,
            message: '请选择面料颜色',
            trigger: 'blur',
          },
        ],
        requestQuantity: [
          {
            required: true,
            validator: checkQuantity,
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    load(ref, val) {
      this.reset()
      this.type = ref
      if (ref === 'add') {
        this.formData.fabricRequestCode = this.params.fabricRequestCode
      } else if (ref === 'edit') {
        this.getData(val)
      }
      this.dialogOption.dialogVisible = true
    },
    loadColor() {
      this.$api
        .bizDict({ dictType: 'colorPantone' })
        .then((res) => {
          this.colorPantoneOptions = res.body.data
        })
        .catch(() => {})
    },
    getData(val) {
      this.formData = val
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let temp = { ...this.formData }
          if (this.type === 'edit') {
            this.$emit('editSuccess', temp)
          } else {
            this.$emit('success', temp)
          }
          this.close()
        } else {
          return false
        }
      })
    },
    close() {
      this.dialogOption.dialogVisible = false
    },
    reset() {
      this.type = ''
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.formData = {
        fabricRequestColorCode: '',
        fabricRequestCode: '',
        fabricCode: '',
        fabricNo: '',
        fabricColorNo: '',
        fabricColorTitle: '',
        requestQuantity: '',
      }
      this.loadColor()
    },
  },
}
</script>
